module.exports = __webpack_public_path__ + "img/icon_instagram_loupe_plus.1723ac43.svg";